import { object } from "yup";
import { baseApi } from "../../redux/baseAPI";
import axios from "axios";
import { getBaseUrl } from "redux/utils";

export const utilitiesApi = baseApi.injectEndpoints({
  tagTypes: ["Utilities", "SearchedIcd10"],
  endpoints: (builder) => ({
    searchCpt: builder.query({
      query: (keyword) => {
        let pid = keyword?.pid;
        let checkKeyWords = keyword?.keyword || keyword;
        let location_id = keyword?.location_id;
        return {
          url: `/utilities/search_cpts.json?keyword=${checkKeyWords}&${
            pid && "pid=" + pid
          }${location_id ? "&location_id=" + location_id : ""}`,
          method: "GET",
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    searchIcd: builder.query({
      query: (keyword) => {
        let params = "";
        if (typeof keyword == "object") {
          params = `keyword=${keyword.keyword}&pid=${keyword.pid}`;
        } else {
          params = `keyword=${keyword}`;
        }
        return {
          url: `/ccm/get_health_conditions_icds.json?${params}`,
          method: "GET",
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    searchSpecialty: builder.query({
      query: (keyword) => {
        return {
          url: `/utilities/listing/specialty.json?keyword=${keyword}`,
          method: "GET",
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    favProcedures: builder.query({
      query: (keyword) => {
        return {
          url: `/notes/get_favorite_components.json?keyword=${keyword.keyword}&components=procedure`,
          method: "GET",
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    searchTest: builder.query({
      query: (keyword) => {
        let params = "";
        if (typeof keyword == "object") {
          params = `${keyword.keyword}&pid=${keyword.pid}&radiology_practice_id=${keyword.radiology_practice_id}`;
        } else {
          params = `keyword=${keyword}`;
        }
        return {
          url: `/radiology/search_observations.json?keyword=${params}`,
          method: "GET",
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    suggestIcd: builder.query({
      query: (params) => {
        return {
          url: `/utilities/suggest_icd10.json?keyword=${params.keyword}&dos=${params.dos}&pid=${params.pid}`,
          method: "GET",
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    searchSuggestedIcd: builder.query({
      query: (params) => {
        return {
          url: `/utilities/search_icd10.json?keyword=${params.keyword}&dos=${params.dos}&pid=${params.pid}`,
          method: "GET",
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providedTags: ["SearchedIcd10"],
    }),
    icdWorkFlow: builder.query({
      query: (params) => {
        return {
          url: `/utilities/icd10_workflow.json?code=${params.code}&dos=${params.dos}&pid=${params.pid}`,
          method: "GET",
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getCcmMeta: builder.query({
      query: (params) => {
        return {
          url: `/ccm/ccm_meta_list.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["Utilities"],
    }),
  }),
});

export function searchDx(keyword) {
  let api_url = getBaseUrl();
  let params = "";
  if (typeof keyword == "object") {
    params = `keyword=${keyword.keyword}&pid=${keyword.pid}`;
  } else {
    params = `keyword=${keyword}`;
  }
  return axios.get(
    `${api_url}/ccm/get_health_conditions_icds.json?${params}`
  );
}
export const { useSuggestIcdQuery, useGetCcmMetaQuery } = utilitiesApi;
